import {
  CsvExportDefinition,
  formatInverseBoolean,
  formatMemberStatus,
  formatUnixSecondsDateTime
} from "../../common/csvExport";

interface MemberExportRecord {
  id: string | number;
  user?: { displayName?: string; email?: string; id?: string };
  role?: { displayName?: string };
  status?: { invitedAt?: number; displayName?: string };
  disabled?: boolean;
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const memberExportDefinition: CsvExportDefinition<MemberExportRecord> = {
  resource: "Member",
  filenameStem: "members",
  id: { header: "memberID", source: "id" },
  columns: [
    {
      key: "displayName",
      label: "Display Name",
      source: "user.displayName",
      getValue: (r) => r.user?.displayName
    },
    {
      key: "email",
      label: "Email",
      source: "user.email",
      getValue: (r) => r.user?.email
    },
    {
      key: "userId",
      label: "User ID",
      source: "user.id",
      getValue: (r) => r.user?.id
    },
    {
      key: "role",
      label: "Role",
      source: "role.displayName",
      getValue: (r) => r.role?.displayName
    },
    {
      key: "invitedAt",
      label: "Date Invited",
      source: "status.invitedAt",
      getValue: (r) =>
        formatUnixSecondsDateTime(r.status?.invitedAt, dateOptions)
    },
    {
      key: "status",
      label: "Status",
      source: "status.displayName",
      getValue: (r) => formatMemberStatus(r.status?.displayName)
    },
    {
      key: "enabled",
      label: "Enabled",
      source: "disabled",
      getValue: (r) => formatInverseBoolean(r.disabled)
    }
  ]
};
